import { sanitizeHTML } from '@/lib/utils'
interface SecOneColProps {
	data?: {
		heading?: {
			title?: string
		}
		text?: {
			text?: string
		}
		options_page?: string[]
		background?: string
		id_section?: string
		class_section?: string
	}
}

export const fields = [
	// headings
	'heading.title',

	// text
	'text.text',

	'id_section',
	'class_section',
	'options_page',
	'background',
] as const

export default function SecOneCol({ data }: SecOneColProps) {
	if (!data) return null

	const textWhite = data.options_page?.includes('text-white')
	
	return (
		<section
			id={data.id_section || undefined}
			className={`SecOneCol w-full py-16 ${data.class_section || ''}`}
			style={data.background ? { backgroundColor: data.background } : undefined}
		>
			<div className={`container ${textWhite ? 'text-white' : ''}`}>
				{data.heading?.title && (
					<h2
						className={`grid gap-2 md:gap-8 w-full mb-8 md:mb-16 md:text-center`}
						dangerouslySetInnerHTML={sanitizeHTML(data.heading.title)}
					/>
				)}

				{/* Single Column */}
				{data.text?.text && (
					<div
						className='flex flex-col gap-6 max-w-none'
						dangerouslySetInnerHTML={sanitizeHTML(data.text.text)}
					/>
				)}
			</div>
		</section>
	)
}
